import React, { useState, useEffect } from "react";

const Breadcrumb = () => {
  const [menuData, setMenuData] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState([]);

  useEffect(() => {
    const storedMenus = JSON.parse(localStorage.getItem("userMENUS")) || [];
    setMenuData(storedMenus);
  }, []); // Runs once when component mounts

  useEffect(() => {
    const currentHash = window.location.hash.replace("#", "");
    //console.log("Url   : " + currentHash);

    const getBreadcrumb = (url) => {
      const breadcrumb = [];
      for (const menu of menuData) {
        for (const submenu of menu.submenus || []) {
          if (submenu.actionUrl === url) {
            breadcrumb.push(menu.menuName, submenu.menuItemName);
            return breadcrumb;
          }
        }
      }
      return breadcrumb;
    };

    setBreadcrumb(getBreadcrumb(currentHash));
  }, [menuData, window.location.hash]); // Runs whenever menuData or URL changes

  const shouldRenderBreadcrumbs = window.location.hash !== "#/welcome";

  return (
    <div>
      {shouldRenderBreadcrumbs && breadcrumb.length > 0 && (
        <nav className="p-3 bg-gradient-to-b from-blue-50 via-white to-blue-100 rounded-xl shadow-lg mb-2">
          {/* <ol>{localStorage.getItem("token").userName}</ol> */}
          <ol className="list-reset flex text-sm text-gray-600">
            {breadcrumb.map((item, index) => (
              <li key={index} className="flex items-center">
                <span
                  className={`${
                    index < breadcrumb.length - 1
                      ? "hover:text-blue-500 cursor-pointer"
                      : "text-gray-800 font-semibold"
                  } uppercase font-medium transition-all`}
                >
                  {item}
                </span>
                {index < breadcrumb.length - 1 && (
                  <span className="mx-2 text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}
    </div>
  );
};

export default Breadcrumb;
